import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import NewCard from './NewCard';
import MinorCard from './MinorCard';
import Reveal, { SectionTitle } from './Reveal';
import { MAJOR_PROJECTS, MINOR_PROJECTS, OS_PROJECTS } from '../data/projects';

const TABS = [
  { key: 'major', label: 'Major', data: MAJOR_PROJECTS, Card: NewCard },
  { key: 'minor', label: 'Minor', data: MINOR_PROJECTS, Card: MinorCard },
  { key: 'os', label: 'Open Source', data: OS_PROJECTS, Card: MinorCard },
];

export default function NewProject() {
  const [active, setActive] = React.useState('major');
  const tab = TABS.find((t) => t.key === active) || TABS[0];
  const Card = tab.Card;

  return (
    <section className="section" id="project">
      <SectionTitle
        eyebrow="Things I've built"
        title="Projects"
        subtitle="Products, tools, and open-source work — click a card for the details."
      />

      <Reveal>
        <div className="skill-tabs" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={active === t.key}
              className={`skill-tab${active === t.key ? ' active' : ''}`}
              onClick={() => setActive(t.key)}
            >
              {t.label}
              <span style={{ opacity: 0.6, marginLeft: 7, fontSize: 12 }}>
                {t.data.length}
              </span>
            </button>
          ))}
        </div>
      </Reveal>

      <AnimatePresence mode="wait">
        <motion.div
          key={tab.key}
          className="proj-grid"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.34, ease: [0.22, 1, 0.36, 1] }}
        >
          {tab.data.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.42, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            >
              <Card list={p} />
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>
    </section>
  );
}
